import type { UserProfileStore } from '../domain/types'
import { useStore } from 'zustand'
import { userProfileStore } from './store'

export function useUserProfileStore<T>(selector: (state: UserProfileStore) => T): T {
  return useStore(userProfileStore, selector)
}
